import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface TextInputDialogProps {
    onClose: (name: string | null) => void,
    open: boolean,
    title: string,
    inputLabel: string,
    cancelText?: string,
    enterText?: string,
    defaultValue?: string
}

const TextInputDialog = (props: TextInputDialogProps) => {
    const { onClose, open, title, inputLabel, cancelText, enterText, defaultValue } = props;
    const [newInput, setNewInput] = useState<string>(defaultValue ?? "");

    useEffect(() => {
        setNewInput(defaultValue ?? "");
    }, [defaultValue]);

    const handleValueEdited = (event: any) => {
        setNewInput(event.target.value);
    };

    const handleEnterText = () => {
        onClose(newInput);
    };

    const handleCancelPressed = () => {
        onClose(null);
    };

    return (
        <Dialog fullWidth maxWidth="xs" open={open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="value"
                    defaultValue={defaultValue}
                    label={inputLabel}
                    onChange={handleValueEdited}
                    type="text"
                    fullWidth
                    variant="standard"
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleCancelPressed}>{cancelText || "Cancel"}</Button>
                <Button variant="contained" color="primary" onClick={handleEnterText}>{enterText || "Enter"}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TextInputDialog;